import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../Util/Session/session.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-support-profile',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent,DataTablesModule],
  templateUrl: './view-support-profile.component.html',
  styleUrl: './view-support-profile.component.scss'
})
export class ViewSupportProfileComponent {
  isDisabled: boolean = false;
  //EmpMasterID : number = 0;
  @Input() InputData: any;
  dtTrigger: Subject<any> = new Subject<any>();
  ViewData : any[] = [];
  public user :any = null
  constructor(public activeModal: NgbActiveModal,
    private route: ActivatedRoute,
    protected common: CommonService,        
    private session :  SessionService,
    private support: SupportTicketService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    //this.route.params.subscribe(params => this.EmpMasterID = parseInt(params['id']));
  }

  ngOnInit(): void {
   this.ViewProfile();
  }
  ViewProfile() {
    const Detail = {
      SelectType: 'Profile',
      EmpMasterId: this.InputData.EmpMasterId,// this.EmpMasterID,
      UserId: this.user.UserId,
      Status: "",
      FromDate: "",
      ToDate: "",
      BranchId: "",
      ClientId: "",
      SiteId: "",
      SiteSupervisorId: "",
      ESS_ComplaintTypeId: ""
    }
    this.isDisabled = true;
    this.support.ESS_HelpDeskRequest(Detail).subscribe({
      next: (data) => {
        console.log(data.Table);
        this.ViewData = data.Table;
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  Cancel(){
    this.activeModal.close();
  }
}
